import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Dialog, useMediaQuery, useTheme } from '@mui/material';
import { mlsListings } from '@prisma/client';
import PropertyInfoDialog from './PropertyInfoDialog';

interface PropertyInfoModalProps {
  mlsListing?: mlsListings;
  mlsListingId?: string;
  isAssumableOnly?: boolean;
  currentMarketRate?: number;
}

const PropertyInfoModal = NiceModal.create<PropertyInfoModalProps>((props) => {
  const modal = useModal();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={modal.visible}
      onClose={() => modal.hide()}
      maxWidth="xl"
      fullWidth
      fullScreen={isMobile}
      sx={{
        zIndex: 1500, // Higher than chat container (1400)
        '& .MuiDialog-paper': {
          borderRadius: isMobile ? 0 : 2,
          overflow: 'hidden',
          height: isMobile ? '100%' : '100vh',
          maxHeight: '100vh',
        },
      }}
    >
      <PropertyInfoDialog {...props} onClose={() => modal.hide()} />
    </Dialog>
  );
});

export default PropertyInfoModal;
